<template>
  <div style="width: 100%;">
    <div class="plan-header">
      <div class="left-title" v-text="$t('adv.adv_title')"></div>
      <div class="right-content">
        {{ $t('adv.condition') }}
        <el-date-picker v-model="date_out" :editable="false" style="margin-left: 5px;" value-format="yyyy-MM-dd" type="daterange" range-separator="~" start-placeholder="" end-placeholder="" size="small" class="jm-picker"></el-date-picker>
      </div>
    </div>
    <div class="chart">
      <div class="button">
        <el-select v-model="type" placeholder="select" size="small" style="width: 120px;" @change="setChart">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <div class="chart-type">
          <i class="fa fa-line-chart" aria-hidden="true"></i>
          <div class="font" v-text="$t('adv.icon_type')"></div>
        </div>
      </div>
      <div id="echarts-records" :style="{width: '100%', height: '200px'}"></div>
    </div>
    <div class="action-lists">
      <div class="add-btn" :title="$t('adv.add_title_adv')" @click="dialogVisible = true"><i class="el-icon-circle-plus"></i></div>
      <div class="condition">
        <i class="fa fa-filter" aria-hidden="true"></i>{{ $t('adv.verify_adv') }}
      </div>
      <div class="table">
        <el-table ref="multipleTable" border show-summary size="mini" @cell-mouse-enter="rowChange" @cell-mouse-leave="leaveRow" :sum-text="$t('adv.sum_text')" :data="tableData" tooltip-effect="dark" style="width: 100%" :header-cell-style="{ 'background-color': '#F4F4F4', 'font-weight': 'bold', 'color': '#333' }">
            <el-table-column :label="$t('adv.td_index')" fixed show-overflow-tooltip width="80">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status" @change="changeStatusOne(scope.$index)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column :label="$t('adv.td_adv')" fixed show-overflow-tooltip width="150">
              <template slot-scope="scope">
                {{ scope.row.title }} <span style="color: #4785DB; cursor: pointer; margin: 0 5px;" @click="showVideoLayer(scope.row.video_path)" v-text="$t('adv.td_video')"></span>
                <i style="color: #0782C3; font-size: 14px; cursor: pointer;" @click="editOne(scope.$index)" class="el-icon-edit-outline" v-if="scope.row['isShowEditIcon'] !== undefined && scope.row['isShowEditIcon']"></i>
              </template>
            </el-table-column>
            <el-table-column prop="plan_title" :label="$t('adv.td_plan')" fixed show-overflow-tooltip width="150"></el-table-column>
            <el-table-column prop="group_name" :label="$t('adv.td_group')" fixed show-overflow-tooltip width="150"></el-table-column>
            <el-table-column :label="$t('adv.td_state')" width="80" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status === false" v-text="$t('adv.state_stop')"></span>
                <span style="color: red;" v-else v-text="$t('adv.state_start')"></span>
              </template>
            </el-table-column>
            <el-table-column prop="start_time" :label="$t('adv.td16')" align="center">
              <template slot-scope="scope">
                {{ plan_type[scope.row.plan_type] }}
              </template>
            </el-table-column>
            <el-table-column prop="click" :label="$t('adv.td7')" align="right"></el-table-column>
            <el-table-column prop="read" :label="$t('adv.td3')" align="right"></el-table-column>
            <el-table-column prop="pay" :label="$t('adv.td5')" align="right">
              <template slot-scope="scope">
                ¥ {{ scope.row.pay }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('adv.td4')" align="right">
              <template slot-scope="scope">
                {{ scope.row.click_l }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('adv.td10')" align="right" width="120">
              <template slot-scope="scope">
                ¥ {{ scope.row.click_p }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('adv.td_doing')" fixed="right" show-overflow-tooltip width="100">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="edit(scope.$index)" v-text="$t('adv.td_edit')"></el-button>
                <el-button type="text" size="mini" @click="delOne(scope.row.adv_id)" v-text="$t('adv.td_delete')"></el-button>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="page-c">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="$t('adv.adv_video_label')"
      :visible.sync="showVideo"
      @close="closeVideo()"
      :close-on-click-modal="false"
      width="30%">
       <video
        v-bind:src="getShowLink(video_path)"
        class="avatar video-avatar"
        controls="controls"
        style="margin-top: 10px; width: 100%;">
           not support the video component!!!
       </video>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeVideo()" v-text="$t('common.layer_btn_cancel')"></el-button>
        <el-button type="primary" @click="showVideo = false" v-text="$t('common.layer_btn_sure')"></el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('adv.edit_adv_title1')" :close-on-click-modal="false" :visible.sync="dialogVisible2" width="30%">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item :label="$t('adv.old_adv_title1')">
          <el-input v-model="old_title" placeholder="" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('adv.new_adv_title1')">
          <el-input v-model="title" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="dialogVisible2 = false" size="mini" v-text="$t('common.layer_btn_cancel')"></el-button>
        <el-button type="primary" @click="sure" size="mini" v-text="$t('common.layer_btn_sure')"></el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('adv.edit_adv_title2')" :visible.sync="dialogVisible" width="30%">
      <div style="padding-bottom: 20px; cursor: pointer;" @click="createAdv(item.group_id)" v-for="(item, index) in group_lists" :key="index" v-text="item.group_name"></div>
    </el-dialog>

  </div>
</template>

<script>
// @ is an alias to /src
import echarts from 'echarts';
export default {
  name: 'index',
  data() {
    return {
      date_out: [],
      options: [{
        value: '2',
        label: this.$t('adv.click')
      }, {
        value: '1',
        label: this.$t('adv.read')
      }, {
        value: '6',
        label: this.$t('adv.pay')
      }],
      type: '2',
      showVideo: false,
      video_path: '',
      keyword: '',
      tableData: [],
      page: 1,
      pageSize: 10,
      pageTotal: 1,
      loading: true,
      ids: [],
      plan_type: ['', this.$t('adv.search'), this.$t('adv.show'), this.$t('adv.shopping'), this.$t('adv.video'), this.$t('adv.ai'), this.$t('adv.find')],
      old_title: '',
      title: '',
      adv_id: '',
      dialogVisible: false,
      dialogVisible2: false,
      group_lists: []
    };
  },
  created() {
    this.setTimeInit();
    this.getData();
  },
  methods: {
    closeVideo() {
      this.showVideo = false;
      this.video_path = '';
    },
    setTimeInit() {
      const day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000 * 7);
      const preToday = day1.getFullYear() + '-' + ((day1.getMonth() + 1) < 10 ? '0' + (day1.getMonth() + 1) : (day1.getMonth() + 1)) + '-' + (day1.getDate() < 10 ? '0' + day1.getDate() : day1.getDate());
      const day2 = new Date();
      day2.setTime(day2.getTime());
      const today = day2.getFullYear() + '-' + ((day2.getMonth() + 1) < 10 ? '0' + (day2.getMonth() + 1) : (day2.getMonth() + 1)) + '-' + (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate());
      this.date_out = [preToday, today];
    },
    showVideoLayer(video_path) {
      this.showVideo = true;
      this.video_path = video_path;
    },
    rowChange(row, column, cell, event) {
      this.$set(row, 'isShowEditIcon', true);
    },
    leaveRow(row, column, cell, event) {
      this.$set(row, 'isShowEditIcon', false);
    },
    setChart() {
      this.$http.post('/trader/data/getTableLists', { value: this.type, pay_time: this.date_out }).then(res => {
        if (res.code === 200) {
          const option = {
            visualMap: [{
              show: false,
              type: 'continuous',
              seriesIndex: 0,
              min: 0,
              max: 400
            }],
            title: [{
              left: 'center',
              text: ''
            }],
            tooltip: {
              trigger: 'axis'
            },
            xAxis: [{
              data: res.static.data
            }],
            yAxis: [{
              splitLine: { show: false }
            }],
            grid: [{
              top: '8%',
              left: '5%',
              right: '5%',
              bottom: '12%'
            }],
            series: [{
              type: 'line',
              showSymbol: false,
              lineStyle: {
                color: res.color,
                width: 1
              },
              data: res.static.value
            }]
          };
          const echartsRecords = echarts.init(document.getElementById('echarts-records'), 'walden');
          echartsRecords.setOption(option);
        }
      });
    },
    getData() {
      this.$http.post('/trader/index/getAdvLists', {
        page: this.page,
        pageSize: this.pageSize
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = Math.ceil(res.count / this.pageSize);
          this.$function.hiddenLoading();
          this.getGroupLists();
          this.setChart();
        }
      });
    },
    getGroupLists() {
      this.$http.post('/trader/index/getGroupPlusData').then((res) => {
        if (res.code === 200) {
          this.group_lists = res.data;
        }
      });
    },
    add() {
      this.$emit('jump_form_plan', []);
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
    changeStatusOne(index) {
      this.ids.push(this.tableData[index].adv_id);
      this.changeStatus(this.tableData[index].status ? 1 : 0);
    },
    changeStatus(val) {
      if (this.ids.length) {
        this.$http.post('/trader/index/changeAdvStatus', {
          ids: this.ids.join(','),
          value: val
        }).then(res => {
          if (res.code === 200) {
            this.getData();
            this.ids = [];
            this.$message.success('操作成功，仅审核通过的创意可修改状态');
          } else {
            this.$message.error('操作失败');
          }
        });
      }
    },
    edit(index) {
      this.$emit('jump_form_adv', this.tableData[index]);
    },
    delOne(id) {
      this.ids.push(id);
      this.del();
    },
    del() {
      if (this.ids.length) {
        this.$http.post('/trader/index/delAdv', {
          ids: this.ids.join(',')
        }).then(res => {
          if (res.code === 200) {
            this.getData();
            this.ids = [];
            this.$message.success('操作成功');
          } else {
            this.$message.error('操作失败');
          }
        });
      }
    },
    editOne(index) {
      const item = this.tableData[index];
      this.old_title = item.title;
      this.title = '';
      this.adv_id = item.adv_id;
      this.dialogVisible2 = true;
    },
    sure() {
      if (this.title === '') {
        this.$message.error('请输入新广告名');
        return false;
      }
      this.$http.post('/trader/index/editAdvTitle', {
        adv_id: this.adv_id,
        title: this.title
      }).then(res => {
        if (res.code === 200) {
          this.dialogVisible2 = false;
          this.getData();
        }
      });
    },
    getShowLink(video_path) {
      return video_path !== '' ? this.$Config.apiUrl + video_path : '';
    },
    createAdv(group_id) {
      this.$emit('group_call_back', group_id);
    }
  },
  watch: {
    date_out(new_val, old_val) {
      this.setChart();
    }
  }
};
</script>

<style lang="less" scoped="">
  .plan-header {
    width: calc(100% - 32px);
    padding: 0 16px;
    height: 48px;
    display: flex;
    flex-shrink: 0;
    background: #fff;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
    justify-content: space-between;
    align-items: center;
    .left-title {
      line-height: 48px;
      font-size: 18px;
      font-weight: 500;
      color: #222;
    }
    .right-content {
      color: #666;
      font-size: 14px;
    }
  }
  .chart {
    height: 230px;
    width: calc(100% - 32px);
    padding: 0 16px;
    margin-top: 10px;
    .button {
      display: flex;
      justify-content: flex-end;
      padding-right: 25px;
      .chart-type {
        font-size: 12px;
        text-align: center;
        color: #666;
        margin-left: 20px;
      }
    }
  }
  .action-lists {
    background: #fff;
    width: calc(100% - 32px);
    padding: 10px 16px 24px 16px;
    position: relative;
    .condition {
      height: 40px;
      line-height: 30px;
      padding-left: 70px;
      font-size: 13px;
      color: #4285F4;
      i {
        font-size: 20px;
        margin-right: 10px;
      }
    }

    .add-btn {
      i {
        color: #1A73E8;
        font-size: 50px;
        cursor: pointer;
        position: absolute;
        top: -20px;
        left: 20px;
      }
    }

    .display {
      display: flex;
      align-items: center;
      height: 50px;
    }
    .left-btns {
      .display;
      div {
        width: 140px;
        height: 100%;
        line-height: 50px;
        text-align: center;
        color: #0056AF;
        cursor: pointer;
      }
      .selected {
        color: #166D9F;
        background: #fff;
      }
    }
    .right-action {
      .display;
      div {
        width: 34px;
        height: 34px;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
  .table {
    width: 100%;
    .make {
      padding: 20px 0;
    }
  }
  .page-c {
    background: #fff;
    padding: 20px;
  }
  img {
    width: 100%;
    height: 100%;
  }
</style>
